import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Which societies are live in Bangalore?",
    a: "We're piloting in 7 societies in Akshay Nagar — including gated mid-rise and high-rise communities — and rapidly onboarding more across South Bangalore. Join the waitlist with your society name and we'll fast-track approvals.",
  },
  {
    q: "What products and equipment do you use?",
    a: "Microfibre wipes, pH-balanced shampoos and pressure or bucket wash depending on what your society allows. Every Zypper carries a standardised kit so the finish is consistent across visits.",
  },
  {
    q: "What happens if my car is damaged during a wash?",
    a: "Every visit has before/after photo verification. If anything goes wrong, raise a dispute in the app — we run a 24-hour investigation and make it right. All our Zyppers are insured.",
  },
  {
    q: "What's the difference between Everyday and Alternate-Day plans?",
    a: "Everyday Zyp visits your parking spot daily for a quick exterior clean, with a deeper interior + detailing routine once a week. Alternate-Day Zyp visits every other day with the deeper detail routine moving to fortnightly. Same Basic / Premium service menu — just a different cadence.",
  },
  {
    q: "Is a bike really included?",
    a: "Yes — one bike is included free with every monthly plan, washed on the same schedule as your car. Need more than one bike covered? It's a flat ₹249/month per extra bike.",
  },
  {
    q: "Can I pause or cancel my subscription?",
    a: "Anytime, no questions asked. Pause for vacations, cancel from the app. There are no contracts, no lock-ins. We earn your business every month.",
  },
  {
    q: "Who are the Zyppers?",
    a: "Background-verified, trained professionals — never gig drifters. They go through a 5-day certification programme, get a uniform, insurance, and a tier system that rewards skill.",
  },
];

export default function FAQs() {
  return (
    <section
      id="faqs"
      data-testid="faq-accordion"
      className="relative py-24 md:py-32 px-6 md:px-12 border-t border-zyp-navy/10 bg-zyp-cream"
    >
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <div className="text-xs uppercase tracking-[0.22em] text-zyp-navy/60 mb-4">
            FAQs
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-zyp-navy">
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-zyp-navy/10"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-base md:text-lg font-medium text-zyp-navy hover:no-underline py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zyp-navy/70 leading-relaxed pb-6 text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
